"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    MALE: 'Male',
    FEMALE: 'Female',
    GENDER_DIVERSE_NON_BINARY: 'Gender diverse/non-binary',
};
//# sourceMappingURL=gender.js.map